module.exports = __webpack_public_path__ + "static/9b2a4eda7c533eeeb2134d5064acf42723498938e24021d106883a56f56485f9-93e47efcfb8b34519dabeaf8746527c9.jpeg";